import { Box } from "@/components/core-components";
import { ShapeIcon, Typography } from "@flash-tecnologia/hros-web-ui-v2";

export const EmployeeErrorsAccordionHeader = () => {
  return (
    <Box gap="xs3" alignItems="center">
      <ShapeIcon
        name="IconInfoCircle"
        variant="info"
        color="var(--color-feedback-info-40)"
        size={32}
        style={{ flexShrink: 0 }}
      />
      <div>
        <Typography.Headline9 color="neutral.20">
          Encontramos pendências nos cadastros
        </Typography.Headline9>
        <Typography.Body4 color="neutral.50">
          Revise os membros incompletos
        </Typography.Body4>
      </div>
    </Box>
  );
};
